import React, { useState, useEffect } from 'react';
import Layout from '../../core/Layout';
import { isAuthenticated } from '../../auth';
import { Link } from 'react-router-dom';
import { getOrder } from '../apiUser';
import { useParams } from 'react-router-dom';
import { senderGenerateShipping } from './apiOrders';
var shippo = require('shippo')('shippo_test_78a3a7e8883b86a4f9d562017f313dfd9b24fb71');

const ConfirmOrder = () => {
    const { user: { _id }, token } = isAuthenticated();
    const priorityId = 'cb6f6532e6e04c7c85d2757dd780ea39'; //XXX put in env
    const serviceLevelToken = 'usps_priority';
    const { orderId } = useParams()
    const [isReciever, setIsReciever] = useState(false);
    //const [firstRate, setFirstRate] = useState(0); //from user to warehouse
    //const [secondRate, setSecondRage] = useState(0); //from warehouse to traded user
    const [toWarehouse, setToWarehouse] = useState({}); //from user to warehouse
    const [toUser, setToUser] = useState({}) //from warehosue to traded user
    const [totalCost ,setTotalCost] = useState(0);
    const [order, setOrder] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
   var warehouse = {
        'name': 'lootswap',
        'street1': '6307 Big Oak Canyon Dr',
        'city': 'Richmond',
        'state': 'TX',
        'zip': 77469,
        'country': 'US'
    };

    useEffect(() => {
        setLoading(true);
        senderGenerateShipping(_id, orderId, token).then(data => console.log(data));
        setLoading(false);
    },[]);

    const showLoading = () => loading && (
        <div className='alert alert-success'>
            <h2> Calculating Costs... </h2>
        </div>
    );
    const showError = () => error && (
        <div className='alert alert-danger'>
            {error}
        </div>
    );
    const showOrderInfo = () => (
        <div className='card'>
            <div className='card-header'>Order Details </div>
            <div className='card-body'>
                {isReciever ? 
                <div>
                    <p> {JSON.stringify(order.recieverShippingInfo)} </p>
                </div>
                        :
                <div>
                    <p> {JSON.stringify(order.senderShippingInfo)} </p>
                </div>
                }
                <Link to={`/user/order/${order._id}`} >
                    <button className='btn btn-warning'> Edit Order Details </button>
                </Link>
            </div>
        </div>
    );
    return(
        <Layout title='Confirm Details'>
            {showError()}
            {showOrderInfo()}
            {showLoading()}
            {totalCost}
        </Layout>
    );
};

export default ConfirmOrder;
